<template>
  <div>
    <fade-in-transition>
      <div
        class="v--modal-overlay"
        @click="openDialog">
        <div
          v-if="isActive"
          class="modal"
          tabindex="-1"
          role="dialog"
          @click="$event.stopPropagation()">
          <div
            class="width-100 modal-header">
            <span
              style="float: right; width: 27px; height: 27px"
              class="close-button"
              @click="openDialog()">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M10.0303 8.96965C9.73741 8.67676 9.26253 8.67676 8.96964
         8.96965C8.67675 9.26255 8.67675 9.73742 8.96964 10.0303L10.9393
          12L8.96966 13.9697C8.67677 14.2625 8.67677 14.7374 8.96966
           15.0303C9.26255 15.3232 9.73743 15.3232 10.0303 15.0303L12
            13.0607L13.9696 15.0303C14.2625 15.3232 14.7374 15.3232
             15.0303 15.0303C15.3232 14.7374 15.3232 14.2625 15.0303
              13.9696L13.0606 12L15.0303 10.0303C15.3232 9.73744 15.3232
               9.26257 15.0303 8.96968C14.7374 8.67678 14.2625 8.67678
                13.9696 8.96968L12 10.9393L10.0303 8.96965Z"
                  fill="#ccc" />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371
           6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75
            12C22.75 6.06294 17.9371 1.25 12 1.25ZM2.75 12C2.75
             6.89137 6.89137 2.75 12 2.75C17.1086 2.75 21.25
              6.89137 21.25 12C21.25 17.1086 17.1086 21.25
               12 21.25C6.89137 21.25 2.75 17.1086 2.75 12Z"
                  fill="#ccc" />
              </svg>
            </span>
            <div class="modal-content shadow">
              <div>
                <client-vocaloid-index
                  :remaining-number="remainingNumber"
                  :already-selected-vocaloid="alreadySelectedVocaloid"
                  :comparable-vocaloid="comparableVocaloid"
                  :is-adding-for-featuring="isAddingForFeaturing"
                  :is-selected-user-artist="isSelectedUserArtist"
                  @is-action-performed="isActionPerformed($event)"
                  @item-to-be-deleted="itemToBeDeleted($event)"
                  @selected-vocaloid="selectedVocaloid($event)" />
              </div>
              <div class="modal-footer">
                <slot name="primary-button">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click.prevent="onModalConfirm">
                    {{ buttonText }}
                  </button>
                </slot>
              </div>
            </div>
          </div>
        </div>
      </div>
    </fade-in-transition>
    <fade-in-transition v-if="showSecondModal">
      <div class="v--modal-overlay">
        <div
          role="dialog"
          class="modal1">
          <div class="modal-content1">
            <h4 class="">ボーカロイド選択</h4>
            <div class="text-center">
              <p class="">
                選択したボーカロイドは保存されません。
              </p>
              <p>
                よろしいですか？
              </p>
            </div>

            <div class="">
              <button
                class="c-btn"
                @click.prevent="onDefaultClicked">
                はい
              </button>
              <button
                class="c-btn c-btn--back"
                @click.prevent="onCancelClicked">
                いいえ
              </button>
            </div>
          </div>
        </div>
      </div>
    </fade-in-transition>
  </div>
</template>

<script>
import FadeInTransition from './Transition/FadeInTransition'
import ClientVocaloidIndex from '../client/components/Release/Vocaloid/Index'

export default {
  name: 'BasicModal',

  components: {
    ClientVocaloidIndex,
    FadeInTransition,
  },

  props: {
    isActive: {
      type: Boolean,
      required: true,
    },
    remainingNumber: {
      type: Number,
      required: true,
    },
    alreadySelectedVocaloid: {
      type: Array,
      required: true,
    },
    comparableVocaloid: {
      type: Array,
      required: true,
    },

    title: {
      type: String,
      required: true,
    },

    body: {
      type: String,
      default: '',
    },

    buttonText: {
      type: String,
      default: '',
    },

    canCancel: {
      type: Boolean,
      default: true,
    },

    width: {
      type: String,
      default: '500px',
    },
    isAddingForFeaturing: {
      type: Boolean,
      required: true,
    },
    isSelectedUserArtist: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      showSecondModal: false,
      selectAction: false,
    }
  },
  methods: {
    onModalConfirm() {
      this.$emit('modal-confirm')
    },

    onModalCancel() {
      this.$emit('modal-cancel')
    },
    selectedVocaloid(event) {
      this.$emit('modalConfirm', event)
      this.$emit('modal-cancel')
    },
    itemToBeDeleted(event) {
      this.$emit('item-to-be-deleted', event)
    },
    openDialog() {
      if (this.selectAction) {
        this.showSecondModal = true
      } else {
        this.$emit('modal-cancel')
      }
    },
    onDefaultClicked() {
      this.showSecondModal = false
      this.$emit('modal-cancel')
    },
    onCancelClicked() {
      this.showSecondModal = false
    },
    isActionPerformed(event) {
      this.selectAction = !this.compareChange(event, this.alreadySelectedVocaloid)
    },
    compareChange(selectedVocaloid, alreadySelectedVocaloid) {
      if (selectedVocaloid.length !== alreadySelectedVocaloid.length) {
        return false
      }
      return selectedVocaloid.every((item1) => alreadySelectedVocaloid.some(
        (item2) => item1.id === item2.id,
      ))
    },
  },
}
</script>

<style type="text/scss" scoped>
.text-center{
  text-align: center;
}
.modal {
  margin: 5rem auto 0;
  z-index: 99;
  display: -webkit-inline-box;
  height: -webkit-fill-available;
  box-shadow: 2px 2px 6px #8080805e;
  background: white;
  height: 85vh;
  padding: 20px;
  overflow: scroll;
  left: 0;
  border: 1px solid #80808054;
  border-radius: 5px;
  transition: ease .3s;
}
.modal-header{
  position: relative;
}

.close-button:hover{
  cursor: pointer;
  fill: #0b0b0b;
}
.close-button{
  position: absolute;
  right: -12px;
  top: -12px;
  z-index: 999;
}
.modal1 {
  position: absolute;
  top: 35vh;
  left: 75vh;
  /*margin: 5rem auto 0;*/
  z-index: 99;
  /*box-shadow: 2px 2px 6px #8080805e;*/
  background: white;
  height: fit-content;
  padding: 20px;
  overflow: scroll;
  border: 1px solid #80808054;
  border-radius: 5px;
  transition: ease .3s;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
}
.modal-content1{
  display: flex;
  flex-direction: column;
  gap: 2rem;
  align-items: center;
  justify-content: center;
}
@media screen and (min-width: 896px) {
  .modal {
    width: 1000px !important;
    right: -290px;
  }
  .modal1 {
    width: 500px;
    right: 223px;
    /*margin-left: 600px;*/
    /*margin-top: 175px;*/
  }
}

@media screen and (max-width: 895px) {
  .modal {
    width: 100vmin;
  }
  .modal1 {
    width: 50vmin;
  }
}
.modal .close {
  position: absolute;
  right: 10px;
  top: 10px;
}

.modal-content {
  max-height: 200px;
}

.modal-body {
  overflow-y: scroll;
  max-height: 200px;
}
.width-100 {
  width: 100%;
}
.text-center {
  text-align: center;
}
.margin-buttom {
  margin-bottom: 25px;
}

.button-div {
  display: flex;
  justify-content: center;
  margin-top: 50px;
}
.c-btn {
  font-size: 1.8rem;
  min-width: 200px;
  padding: 17px 40px;
  text-align: center;
  margin-right: 5px;
}

</style>
